import { useState, useEffect } from 'react'
import { useTelegram } from './use-telegram'
import { useAuthStore } from '@/stores/auth'

export function useAuth() {
  const { initData, user: telegramUser, isReady } = useTelegram()
  const { 
    user, 
    token, 
    isAuthenticated, 
    login, 
    logout, 
    checkAuth,
    setLoading
  } = useAuthStore()
  
  const [isLoading, setIsLoadingLocal] = useState(true)

  // Auto authentication
  useEffect(() => {
    async function authenticate() {
      if (!isReady) {
        return
      }

      setLoading(true)
      setIsLoadingLocal(true)

      try {
        // Check if we already have a valid token
        const hasValidToken = await checkAuth()
        
        if (!hasValidToken && initData) {
          // Use Telegram initData for authentication
          await login(initData)
        } else if (!hasValidToken && !initData) {
          // No valid token and no Telegram data - not authenticated
          setLoading(false)
          setIsLoadingLocal(false)
          return
        }
      } catch (error) {
        console.error('Authentication failed:', error)
      } finally {
        setLoading(false)
        setIsLoadingLocal(false)
      }
    }

    authenticate()
  }, [isReady, initData, login, checkAuth, setLoading])

  return {
    user,
    telegramUser,
    token,
    isAuthenticated,
    isLoading,
    login,
    logout,
  }
}